import { Stethoscope } from 'lucide-react';
import { Skeleton, Spinner } from '@/components/ui/Feedback';

/**
 * Экран 29. Состояние загрузки.
 * Показывается на холодном старте, пока проверяется сессия мессенджера.
 */
export function BootScreen() {
  return (
    <div
      className="mx-auto flex w-full max-w-[520px] flex-col items-center justify-center px-6 text-center"
      style={{ minHeight: 'var(--bd-viewport-height)' }}
    >
      <span
        className="flex h-[72px] w-[72px] items-center justify-center rounded-[22px] bg-brand-deep text-white"
        aria-hidden
      >
        <Stethoscope className="h-8 w-8" />
      </span>

      <Spinner size={28} className="my-5" />
      <h2 className="text-[17px] font-medium">Загружаем ваш курс</h2>
      <p className="mt-1.5 text-[11px] text-muted">Проверяем доступ</p>
      <Skeleton lines={3} className="mt-5 w-4/5" />

      {/* Метка сборки: по ней видно, какая версия реально открыта у пользователя */}
      <span className="mt-6 text-[10px] text-muted/70">сборка {__BUILD_ID__}</span>
    </div>
  );
}
